import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface JoinGameFormProps {
  onJoinGame: (gameCode: string) => void;
}

const JoinGameForm: React.FC<JoinGameFormProps> = ({ onJoinGame }) => {
  const { t } = useTranslation();
  const [gameCode, setGameCode] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!gameCode.trim()) return;
    onJoinGame(gameCode.trim().toUpperCase());
  };

  return (
    <div className="w-full flex justify-center">
      <form onSubmit={handleSubmit} className="flex w-full max-w-sm min-w-70 bg-white/95 rounded-3xl overflow-hidden shadow-md border-2 border-white/80">
        <input
          id="gameCode"
          type="text"
          value={gameCode}
          onChange={(e) => setGameCode(e.target.value)}
          placeholder={t('home.enterCode')}
          className="flex-1 py-4 px-6 border-none bg-transparent text-center uppercase font-semibold tracking-widest text-slate-700 placeholder:text-gray-400 placeholder:font-normal placeholder:tracking-normal focus:outline-none"
          maxLength={6}
        />
        <button 
          type="submit"
          disabled={!gameCode.trim()}
          className="w-30 flex-shrink-0 bg-green-500 hover:bg-green-600 disabled:opacity-70 text-white font-bold py-4 px-4 text-sm uppercase tracking-wide cursor-pointer border-2 border-green-500 hover:-translate-y-0.5 hover:shadow-lg transition-all duration-300"
        >
          {t('common.join')}
        </button>
      </form>
    </div>
  );
};

export default JoinGameForm;